<template>
  <div class="content">
    <h1 class="is-hidden">Übersicht über alle Elektrotechnik Rechner</h1>
    <div class="box">
      <h2 class="has-text-centered" id="allgemein">Allgemein</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-ohms-law'}" class="inherited">
                  <div class="p-2">
                    Ohmsches Gesetz
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-circular-frequency'}" class="inherited">
                  <div class="p-2">
                    Kreisfrequenz
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-impedance'}" class="inherited">
                  <div class="p-2">
                    Scheinwiderstand (Impedanz)
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-electric-charge'}" class="inherited">
                  <div class="p-2">
                    Elektrische Ladung
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-electric-density'}" class="inherited">
                  <div class="p-2">
                    Elektrische Stromdichte
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-electric-field-strength'}" class="inherited">
                  <div class="p-2">
                    Elektrische Feldstärke
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-magnetic-flux-density'}" class="inherited">
                  <div class="p-2">
                    Magnetische Flussdichte
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-ac-effective-values'}" class="inherited">
                  <div class="p-2">
                    Effektivwerte bei Wechselstrom
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box">
      <h2 class="has-text-centered" id="leistung">Leistung</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-dc-power'}" class="inherited">
                  <div class="p-2">
                    Leistung bei Gleichstrom
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-ac-power'}" class="inherited">
                  <div class="p-2">
                    Leistung bei Wechselstrom
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box">
      <h2 class="has-text-centered" id="bauteile-schaltungen">Bauteile & Schaltungen</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-led-resistor'}" class="inherited">
                  <div class="p-2">
                    Vorwiderstand einer LED
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-battery-charging-time'}" class="inherited">
                  <div class="p-2">
                    Ladezeit eines Akkus
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-transformator-efficiency'}" class="inherited">
                  <div class="p-2">
                    Wirkungsgrad eines Transformators
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-inductance-coil'}" class="inherited">
                  <div class="p-2">
                    Induktivität einer Spule
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-coil-magnetic-flux'}" class="inherited">
                  <div class="p-2">
                    Magnetische Durchflutung einer Spule
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-coil-magnetic-field-strength'}" class="inherited">
                  <div class="p-2">
                    Magnetische Feldstärke einer Spule
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-capacitor-capacitance'}" class="inherited">
                  <div class="p-2">
                    Kapazität eines Kondensators
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-transistor-dc'}" class="inherited">
                  <div class="p-2">
                    Transistor bei Gleichstrom
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-rc-circuit-time-constant'}" class="inherited">
                  <div class="p-2">
                    Zeitkonstante eines RC-Glieds
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-rc-circuit-cutoff-freq'}" class="inherited">
                  <div class="p-2">
                    Grenzfrequenz eines RC-Glieds
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'calculator-lc-circuit-cutoff-freq'}" class="inherited">
                  <div class="p-2">
                    Grenzfrequenz eines LC-Glieds
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-calculators',
  metaInfo: {
    title: 'Übersicht über alle Elektrotechnik Rechner',
    meta: [
      {
        name: 'description',
        content: 'Eine Sammlung vieler verschiedener Elektrotechnik Rechner. Formel auswählen, Werte eintragen und Ergebnis berechnen lassen.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Rechner', route: 'start' })
  }
}
</script>
